<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()">
  <div class="spacing--padding-all" data-test="location__detail">
    <form [formGroup]="form" [agrConnectForm]="details$" (ngSubmit)="save()">
      <div class="form-field-wrapper">
        <div class="text--h5">{{ 'app.customer.detail.title_general' | translate }}</div>
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.name' | translate }}"
            formControlName="name"
            data-test="customer-location__name"
          />
          @if (form.controls.name.invalid) {
            <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'app.customer.detail.location_type' | translate }}</mat-label>
          <mat-select formControlName="locationType" data-test="customer-location__type">
            @for (locationType of locationtypes; track locationType) {
              <mat-option [value]="locationType">
                {{ locationType }}
              </mat-option>
            }
          </mat-select>
          @if (form.controls.locationType.invalid) {
            <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
          }
        </mat-form-field>

        <div class="text--h5">{{ 'app.customer.detail.title_address' | translate }}</div>
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.street' | translate }}"
            formControlName="street"
            data-test="customer-location__street"
          />
          @if (form.controls.street.invalid) {
            <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.postal_code' | translate }}"
            formControlName="postalCode"
            data-test="customer-location__postal-code"
          />
          @if (form.controls.postalCode.invalid) {
            <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
          }
        </mat-form-field>

        <div class="flex--row flex--gutter">
          <mat-form-field class="flex__child--auto">
            <input
              matInput
              agrNumber
              placeholder="{{ 'app.customer.detail.house_number' | translate }}"
              formControlName="houseNumber"
              data-test="customer-location__house-number"
            />
            @if (form.controls.houseNumber.invalid) {
              <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <input
              matInput
              inputmode="text"
              placeholder="{{ 'app.customer.detail.house_number_addition' | translate }}"
              formControlName="houseNumberAddition"
              data-test="customer-location__house-number-addition"
            />
          </mat-form-field>
        </div>

        <div class="flex--row flex--gutter">
          <mat-form-field class="flex__child--auto">
            <input
              matInput
              inputmode="text"
              placeholder="{{ 'app.customer.detail.city' | translate }}"
              formControlName="city"
              data-test="customer-location__city"
            />
            @if (form.controls.city.invalid) {
              <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'app.customer.detail.country' | translate }}</mat-label>
            <mat-select formControlName="country" data-test="customer-location__country">
              <mat-option>-</mat-option>
              @for (country of countries; track country) {
                <mat-option [value]="country.countryCode">
                  {{ 'app.countries.' + country.countryCode | translate }}
                </mat-option>
              }
            </mat-select>
            @if (form.controls.country.invalid) {
              <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="text--h5">{{ 'app.customer.detail.title_contact' | translate }}</div>
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.phone_number' | translate }}"
            formControlName="phoneNumber"
            data-test="customer-location__phone-number"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.mobile_number' | translate }}"
            formControlName="mobileNumber"
            data-test="customer-location__mobile-number"
          />
        </mat-form-field>

        <div class="spacing--margin-top mat-button-row">
          <button
            type="submit"
            mat-flat-button
            class="flex__child"
            color="primary"
            data-test="customer-location__save"
          >
            {{ 'save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</agr-page-detail>
